import { createSlice } from "@reduxjs/toolkit";

const initialState = null;

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logining: (state, action) => {
      return (state = action.payload);
    },
    loginingOut: (state, action) => {
      return (state = null);
    },
  },
});

export const { logining, loginingOut } = userSlice.actions;
export default userSlice.reducer;
